import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import * as firebase from 'firebase';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.css']
})
export class UserProfileComponent implements OnInit {

  uid: string = "";
  user: any = {};

  constructor(private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.uid = params['id'];
      this.getUser();
    });
  }

  getUser() {
    firebase.database().ref(`/users/${this.uid}`)
      .once("value")
      .then(snapshot => {
        if (snapshot.val()) {
          this.user = snapshot.val();
        } else {
          this.router.navigate([`dashboard`]);
        }
      })
  }

  toggleSuspend(status) {
    firebase.database().ref(`/users/${this.uid}/isSuspended`).set(status);

    this.user.isSuspended = status;
  }

  getFollowingCount() {
    var count = 0;

    if (!this.user.following) {
      this.user.following = {};
    }

    for (var key in this.user.following) {
      if (this.user.following[key]) {
        count++;
      }
    }

    if (!this.user.followingPlaces) {
      this.user.followingPlaces = {};
    }

    for (var key in this.user.followingPlaces) {
      if (this.user.followingPlaces[key]) {
        count++;
      }
    }

    return count;
  }

  getFollowersCount() {
    var count = 0;

    if (!this.user.followers) {
      this.user.followers = {};
    }

    for (var key in this.user.followers) {
      if (this.user.followers[key]) {
        count++;
      }
    }

    return count;
  }

  getRating() {
    var count = 0;

    if (!this.user.followers) {
      this.user.followers = {};
    }

    for (var key in this.user.followers) {
      if (this.user.followers[key]) {
        count++;
      }
    }

    if (count < 1) {
      return 0;
    } else if (count < 5) {
      return 1;
    } else if (count < 10) {
      return 2;
    } else if (count < 20) {
      return 3;
    } else if (count < 50) {
      return 4
    } else {
      return 5;
    }
  }

}
